import { LegacyDevice } from 'console/device/device';
import { prettyFloat } from 'webui/utils/number';
import { isRadioThermometer } from 'console/shared/content/device/thermometers/legacy/utils';
import { vehicle_thermometers_state } from 'console/shared/content/device/thermometers/vehicle/utils';
import { useSelectDevice } from '../index';
import { getLegacyOpenThermState } from './open-therm';
import { useLegacyDeviceState } from './index';
import { OpenThermVariableName } from 'openTherm';
import { createSelector } from 'reselect';
import { ThermometerState } from 'webui/utils/thermometers';
const getLegacyRadioThermometerState = createSelector((config) => config.serial, (config, device_state) => {
    const thermometers = LegacyDevice.active_thermometers(device_state?.thermometers || []);
    const thermometer = thermometers.find((thermometer) => config.serial === thermometer.serial);
    return thermometer ?? null;
}, (config, device_state) => device_state.rf_status, (serial, default_thermometer, rf_status) => {
    const is_radio_thermometer = !default_thermometer || isRadioThermometer(default_thermometer);
    if (rf_status != null && serial && is_radio_thermometer) {
        const thermometer = rf_status[serial];
        if (thermometer != null) {
            const { dbm, bat, bat_v, temp, type, time } = thermometer;
            const rf_indicators = { dbm, bat, bat_v, type, time };
            return { rf_indicators, temperature: temp, state: ThermometerState.ok };
        }
        else {
            return { state: ThermometerState.malfunction };
        }
    }
    return null;
});
const getLegacyInternetThermometerState = createSelector((config) => config.open_therm, (config, device_state) => device_state.last_boiler_state, (config, device_state) => device_state.internet_weather, (open_therm, last_boiler_state, internet_weather) => {
    if (open_therm && last_boiler_state?.ot) {
        const temperature = last_boiler_state.ot[OpenThermVariableName.ot];
        const state = last_boiler_state?.fail
            ? ThermometerState.malfunction
            : ThermometerState.ok;
        if (temperature) {
            return { temperature, state };
        }
    }
    return {
        temperature: internet_weather,
        state: ThermometerState.ok,
    };
});
const getLegacyOpenThermThermometerState = createSelector((config) => config.open_therm.ot_name, (config, device_state) => getLegacyOpenThermState(config.boiler_adapter_id ?? config.id, device_state), (ot_name, open_therm_state) => {
    const ot_value = open_therm_state?.[ot_name];
    const temperature = typeof ot_value === 'number' ? Number(prettyFloat(ot_value, 1)) : undefined;
    return {
        temperature,
        state: ThermometerState.ok,
    };
});
const getLegacyThermometerState = createSelector((config) => config.owa, (config, device_state) => {
    const thermometers = LegacyDevice.active_thermometers(device_state?.thermometers || []);
    const thermometer = thermometers.find((thermometer) => config.serial === thermometer.serial);
    return thermometer ?? {};
}, (owa, thermometer) => {
    const { last_state, last_value } = thermometer;
    const temperature = last_value
        ? Number(prettyFloat(last_value * (owa?.multiplier ?? 1), 1))
        : undefined;
    return { temperature, state: last_state };
});
export const getLegacyThermometersState = (config, device_state) => {
    const { open_therm, is_internet_thermometer } = config;
    //в thermometers не все радиодатчики
    //поэтому берем их только из rf_status
    const radio_thermometer = getLegacyRadioThermometerState(config, device_state);
    if (radio_thermometer) {
        return radio_thermometer;
    }
    if (is_internet_thermometer) {
        return getLegacyInternetThermometerState(config, device_state);
    }
    if (open_therm) {
        return getLegacyOpenThermThermometerState(config, device_state);
    }
    return getLegacyThermometerState(config, device_state);
};
export const useVehicleThermometerState = () => {
    const initial_state = useSelectDevice(vehicle_thermometers_state);
    const device_state = useLegacyDeviceState(initial_state);
    return device_state;
};
